export default (width = 20, height = 20, color = '#E65050') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
        <circle cx="10" cy="10" r="10" fill="${color}"/>
        <path fill="#FFF" d="M9.9 16.4c-.882 0-1.5-.706-1.5-1.5 0-.882.706-1.5 1.5-1.5.882 0 1.5.618 1.5 1.5 0 .794-.618 1.5-1.5 1.5zm.843-4.935c-.229.713-1.257.713-1.486 0C9.03 10.75 8 7.283 8 5.142 8 3.714 9.257 3 9.943 3 10.629 3 12 3.714 12 5.142c0 2.141-1.029 5.507-1.257 6.323z"/>
    </g>
</svg>
`